// https://www.npmjs.com/package/google-maps
import GoogleMapsLoader from 'google-maps'

GoogleMapsLoader.KEY = 'AIzaSyDGJuZ710E74n3LJ-GsNdIUowBslhwe05Y'
GoogleMapsLoader.LIBRARIES = ['places']

export default GoogleMapsLoader



// WEBPACK FOOTER //
// ./app/javascript/lib/google-maps.js